var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftnavarrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Search bar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow_forward_ios"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3183_1918",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    transform: "matrix(-1 0 0 1 29 6)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3183_1918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_forward_ios_2",
    d: "M20.9098 26L22.0859 24.8239L15.2621 18L22.0859 11.1761L20.9098 10L12.9098 18L20.9098 26Z",
    fill: "var(--primary-btn-text)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftnavarrow);
export default __webpack_public_path__ + "static/media/leftnavarrow.6cffa0dbffd30dcca4c934c6a4890e74.svg";
export { ForwardRef as ReactComponent };